import NurseryLayout from "src/app/layouts/NurseryLayout"
import FeedContainer from "./components/FeedContainer"
import { ChildrenStoreData } from "src/shared/types/src";
import { getCurrentChild, getEyManSettingsLoading } from "src/shared/redux-state/src";
import { useAppSelector } from "src/app/services/store";
import LocalImages from './../../static';
import { FullScreenLoader } from "src/app/components";


const Eyengage: React.FC = () => {
    const currentChild: ChildrenStoreData = useAppSelector(getCurrentChild);
    const eyManSettingsLoading: boolean = useAppSelector(getEyManSettingsLoading);

    const renderFeatureNotEnabled = () => {
        return (
            <div className="d-flex flex-column align-items-center justify-content-center no-posts-container">
            <img src={LocalImages.noPostFound} alt="eyengage-empty" className="no-posts-image" />
            <p className="mg-b-0 fs-14 text-black fw-semibold mt-2">This feature is not enabled by your childcare provider</p>
          </div>
        )
    }
    return (
        <NurseryLayout fixedFooter={true}>
            {!eyManSettingsLoading ?
                <>
                    {
                        Boolean(currentChild?.systemsEnabled?.eyengage) ?
                            <FeedContainer /> :
                            renderFeatureNotEnabled()
                    }
                </> :
                <FullScreenLoader />
            }   
        </NurseryLayout>
    )
}

export default Eyengage